import { Phone, MessageCircle, Mail, Clock } from "lucide-react";
import { EMAIL, EMAIL_HREF, HOURS, PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "@/lib/site";

const Item = ({ href, icon: Icon, label, value, testId, external }) => (
  <a href={href} data-testid={testId} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    className="group flex items-center gap-4 rounded-2xl border border-white/10 p-4 transition-colors duration-300 hover:bg-white/5">
    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[var(--green)] text-white transition-transform duration-300 group-hover:scale-110"><Icon className="h-5 w-5" /></span>
    <span className="min-w-0">
      <span className="block text-xs uppercase tracking-wider text-slate-400">{label}</span>
      <span className="block font-semibold text-white break-all">{value}</span>
    </span>
  </a>
);

export const ContactCard = () => (
  <div className="rounded-[1.75rem] bg-[var(--navy)] p-6 sm:p-8 text-white grain relative overflow-hidden" data-testid="contact-card">
    <div className="relative">
      <h2 className="font-display text-2xl font-bold">Prefer to talk?</h2>
      <p className="mt-2 text-slate-300">Call, message or email – whichever suits you.</p>
      <div className="mt-6 space-y-3">
        <Item href={PHONE_TEL} icon={Phone} label="Call us" value={PHONE_DISPLAY} testId="contact-click-to-call-button" />
        <Item href={WHATSAPP_URL} icon={MessageCircle} label="WhatsApp" value={PHONE_DISPLAY} testId="contact-whatsapp-button" external />
        <Item href={EMAIL_HREF} icon={Mail} label="Email" value={EMAIL} testId="contact-email-link" />
      </div>
      <div className="mt-6 rounded-2xl bg-white/5 p-5">
        <p className="flex items-center gap-2 text-sm font-semibold"><Clock className="h-4 w-4 text-[var(--green-bright)]" /> Opening hours</p>
        <ul className="mt-3 space-y-1 text-sm">
          {HOURS.map((h) => <li key={h.day} className="flex justify-between gap-4"><span className="text-slate-300">{h.day}</span><span>{h.time}</span></li>)}
        </ul>
      </div>
    </div>
  </div>
);
